<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc"><b>Table of Contents</b></h2>
<p class="toc"><a href="#/Text/05_9781455619825_Introduction">Introduction</a></p>
<p class="toc"><a href="#/Text/06_9781455619825_Chapter_01">1. November 22, 1963: The Basic Facts</a></p>
<p class="toc"><a href="#/Text/07_9781455619825_Chapter_02">2. The Autopsy</a></p>
<p class="toc"><span href="#/Text/08_9781455619825_Chapter_03" title="Link target outside of Sample">3. The Non-Investigation</span></p>
<p class="toc"><span href="#/Text/09_9781455619825_Chapter_04" title="Link target outside of Sample">4. A Fork in the Road</span></p>
<p class="toc"><span href="#/Text/10_9781455619825_Chapter_05" title="Link target outside of Sample">5. Cuba—Rosetta Stone to the Assassination</span></p>
<p class="toc"><span href="#/Text/11_9781455619825_Chapter_06" title="Link target outside of Sample">6. Who Was Lee Harvey Oswald?</span></p>
<p class="toc"><span href="#/Text/12_9781455619825_Chapter_07" title="Link target outside of Sample">7. Jack Ruby: Screwball or Mob Pawn?</span></p>
<p class="toc"><span href="#/Text/13_9781455619825_Chapter_08" title="Link target outside of Sample">8. The Case Against Oswald</span></p>
<p class="toc"><span href="#/Text/14_9781455619825_Chapter_09" title="Link target outside of Sample">9. The Enigma of Dealey Plaza</span></p>
<p class="toc"><span href="#/Text/15_9781455619825_Chapter_10" title="Link target outside of Sample">10. Conclusions</span></p>
<p class="toc"><span href="#/Text/16_9781455619825_Chapter_11" title="Link target outside of Sample">11. The Cover-Up—Villains &amp; Heroes</span></p>
<p class="toc"><span href="#/Text/17_9781455619825_Chapter_12" title="Link target outside of Sample">12. Keeping the Lid On</span></p>
<p class="toc"><span href="#/Text/18_9781455619825_Epilog" title="Link target outside of Sample">Epilog</span></p>
<p class="toc"><span href="#/Text/19_9781455619825_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Text/20_9781455619825_Sources" title="Link target outside of Sample">Sources</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_9781455619825_Contents.vue?234e8030